module.exports = __webpack_public_path__ + "static/img/4.138232d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/eng/4.png
// module id = dvN/
// module chunks = 0